import { Component, OnInit } from '@angular/core';
import { CouponService } from 'app/core/services/coupon.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';
import { BaseBusinessCoupon } from '../base-businessCoupon';

@Component({
  selector: 'app-business-coupons',
  
  templateUrl: './business-coupons.component.html',
  styleUrl: './business-coupons.component.scss'
})
export class BusinessCouponsComponent extends BaseBusinessCoupon  implements OnInit{
  constructor(public localizationService: LocalizationService, public commonService: CommonService,public couponService:CouponService) {
    super(couponService,localizationService,commonService)
  }
  ngOnInit(): void {
    this.init()    
  }
  onLoadData(event) {
    this.request.Paging = event.Paging;
    this.loadBusinessCoupons();
  }

}
